export default "__VITE_ASSET__Dz_ak$Kb__"